"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentConfig = void 0;
var ContentConfig = {
  document: {
    type: 'document',
    mdIcon: 'description'
  },
  video: {
    type: 'video',
    mdIcon: 'play_circle_filled'
  },
  test: {
    type: 'test',
    mdIcon: 'live_help'
  },
  survey: {
    type: 'survey',
    mdIcon: 'inventory'
  },
  assignment: {
    type: 'assignment',
    mdIcon: 'ballot'
  },
  webinar: {
    type: 'webinar',
    mdIcon: 'podcasts'
  },
  webcontent: {
    type: 'webcontent',
    mdIcon: 'document_scanner'
  }
};
exports.ContentConfig = ContentConfig;